import { render, staticRenderFns } from "./FinalizacaoRecusarDialog.vue?vue&type=template&id=0ffef2f7"
import script from "./FinalizacaoRecusarDialog.vue?vue&type=script&lang=js"
export * from "./FinalizacaoRecusarDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports